export default __webpack_public_path__ + "static/media/logo.9dd4b42d.png";